import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Input from '../../Input';
import EmailPhoneInput, { INPUT_TYPE } from '../../EmailPhoneInput';
import Button from '../../Button';
import DismissCircleIcon from '../../../icons/DismissCircleIcon';

const propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    phone_or_email: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onEnter: PropTypes.func.isRequired,
};

const ContactTile = ({ contact, onChange, onRemove, onEnter }) => {
  const [name, setName] = useState(contact.name);
  const [phoneOrEmail, setPhoneOrEmail] = useState(contact.phone_or_email);

  return (
    <div className="contact-tile">
      <div className="w-100 mr-1">
        <Input
          id={`contact-name-${contact.id}`}
          name={`name-${contact.id}`}
          placeholder="Contact name"
          value={name}
          onChange={event => {
            setName(event.target.value);
            onChange(event, 'name', contact.is_email, contact.id);
          }}
          className="mb-1"
        />
        <EmailPhoneInput
          id={`contact-phone-or-email-${contact.id}`}
          name={`phone-or-email-${contact.id}`}
          className="mb-0"
          placeholder="Email address"
          value={phoneOrEmail}
          onChange={(value, isPhone) => {
            setPhoneOrEmail(value);
            onChange(
              { target: { value, is_phone: isPhone } },
              'phone_or_email',
              !isPhone,
              contact.id,
            );
          }}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              onEnter();
            }
          }}
          defaultInputType={
            contact.is_email ? INPUT_TYPE.EMAIL : INPUT_TYPE.PHONE
          }
        />
      </div>
      <Button btnStyle="reset" className="tile-dismiss-btn" onClick={onRemove}>
        <DismissCircleIcon size={20} color="#fe5851" />
      </Button>
    </div>
  );
};

ContactTile.propTypes = propTypes;

export default ContactTile;
